import { createTheme } from "@mui/material/styles";
import APP_CONFIGURATION from "./app.config";
const MuscleMuiTheme = createTheme({
  typography: {
    fontFamily: "Figtree"
  },
  palette: {
    primary: {
      main: APP_CONFIGURATION.colors.primary_main,
      contrastText: "#FFF",
      "100": APP_CONFIGURATION.colors.primary_100,
      "200": APP_CONFIGURATION.colors.primary_200,
      "300": APP_CONFIGURATION.colors.primary_300,
      "400": APP_CONFIGURATION.colors.primary_400,
      "500": APP_CONFIGURATION.colors.primary_500,
      "600": APP_CONFIGURATION.colors.primary_600,
      "700": APP_CONFIGURATION.colors.primary_700,
      "800": APP_CONFIGURATION.colors.primary_800,
      "900": APP_CONFIGURATION.colors.primary_900,
      "50": APP_CONFIGURATION.colors.primary_50
    },
    secondary: {
      main: APP_CONFIGURATION.colors.secondary_main,
      "100": APP_CONFIGURATION.colors.secondary_100,
      "200": APP_CONFIGURATION.colors.secondary_200,
      "300": APP_CONFIGURATION.colors.secondary_300,
      "400": APP_CONFIGURATION.colors.secondary_400,
      "500": APP_CONFIGURATION.colors.secondary_500,
      "600": APP_CONFIGURATION.colors.secondary_600,
      "700": APP_CONFIGURATION.colors.secondary_700,
      "800": APP_CONFIGURATION.colors.secondary_800,
      "900": APP_CONFIGURATION.colors.secondary_500,
      "50": APP_CONFIGURATION.colors.secondary_50
    },
    error: {
      main: APP_CONFIGURATION.colors.error_500,
      "100": APP_CONFIGURATION.colors.error_100,
      "200": APP_CONFIGURATION.colors.error_200,
      "300": APP_CONFIGURATION.colors.error_300,
      "400": APP_CONFIGURATION.colors.error_400,
      "500": APP_CONFIGURATION.colors.error_500,
      "600": APP_CONFIGURATION.colors.error_600,
      "700": APP_CONFIGURATION.colors.error_700,
      "800": APP_CONFIGURATION.colors.error_800,
      "900": APP_CONFIGURATION.colors.error_900,
      "50": APP_CONFIGURATION.colors.error_50
    },
    warning: {
      main: APP_CONFIGURATION.colors.warning_main,
      "100": APP_CONFIGURATION.colors.warning_100,
      "200": APP_CONFIGURATION.colors.warning_200,
      "300": APP_CONFIGURATION.colors.warning_300,
      "400": APP_CONFIGURATION.colors.warning_400,
      "500": APP_CONFIGURATION.colors.warning_500,
      "600": APP_CONFIGURATION.colors.warning_600,
      "700": APP_CONFIGURATION.colors.warning_700,
      "800": APP_CONFIGURATION.colors.warning_800,
      "900": APP_CONFIGURATION.colors.warning_900,
      "50": APP_CONFIGURATION.colors.warning_50
    },
    info: {
      main: APP_CONFIGURATION.colors.neutral_500,
      "100": APP_CONFIGURATION.colors.neutral_100,
      "200": APP_CONFIGURATION.colors.neutral_200,
      "300": APP_CONFIGURATION.colors.neutral_300,
      "400": APP_CONFIGURATION.colors.neutral_400,
      "500": APP_CONFIGURATION.colors.neutral_500,
      "600": APP_CONFIGURATION.colors.neutral_600,
      "700": APP_CONFIGURATION.colors.neutral_700,
      "800": APP_CONFIGURATION.colors.neutral_800,
      "900": APP_CONFIGURATION.colors.neutral_900,
      "50": APP_CONFIGURATION.colors.neutral_50
    },
    success: {
      main: APP_CONFIGURATION.colors.success_main,
      "100": APP_CONFIGURATION.colors.success_100,
      "200": APP_CONFIGURATION.colors.success_200,
      "300": APP_CONFIGURATION.colors.success_300,
      "400": APP_CONFIGURATION.colors.success_400,
      "500": APP_CONFIGURATION.colors.success_500,
      "600": APP_CONFIGURATION.colors.success_600,
      "700": APP_CONFIGURATION.colors.success_700,
      "800": APP_CONFIGURATION.colors.success_800,
      "900": APP_CONFIGURATION.colors.success_900,
      "50": APP_CONFIGURATION.colors.success_50
    },
    action: {
      activatedOpacity: 0.12,
      hoverOpacity: 0.08,
      selectedOpacity: 0.08,
      disabledOpacity: 0.38
    },
    background: {
      default: APP_CONFIGURATION.colors.white
    }
  },
  components: {
    MuiAccordion: {
      defaultProps: {
        sx: {
          borderColor: APP_CONFIGURATION.colors.neutral_600,
          border: "1px solid",
          borderRadius: "1rem !important",
          boxShadow: "none"
        }
      }
    },
    MuiInputLabel: {
      defaultProps: {
        sx: {
          color: APP_CONFIGURATION.colors.neutral_700
        }
      }
    },
    MuiOutlinedInput: {
      defaultProps: {
        sx: {
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: APP_CONFIGURATION.colors.neutral_700
          },
          "& svg": {
            color: APP_CONFIGURATION.colors.neutral_700
          }
        }
      },
      styleOverrides: {
        root: {
          borderRadius: 8
        }
      }
    }
  }
});
export const WhiteInputsMuscleMuiTheme = createTheme({
  palette: {
    primary: {
      contrastText: APP_CONFIGURATION.colors.primary_main,
      main: APP_CONFIGURATION.colors.white
    },
    secondary: {
      main: APP_CONFIGURATION.colors.secondary_main,
      contrastText: APP_CONFIGURATION.colors.white
    },
    background: {
      default: APP_CONFIGURATION.colors.primary_main
    }
  },
  typography: {
    fontFamily: "Figtree"
  },
  components: {
    MuiDivider: {
      defaultProps: {
        sx: {
          backgroundColor: APP_CONFIGURATION.colors.neutral_500
        }
      }
    },
    MuiAccordion: {
      defaultProps: {
        sx: {
          borderColor: APP_CONFIGURATION.colors.neutral_600,
          border: "1px solid",
          borderRadius: "1rem !important",
          boxShadow: "none"
        }
      }
    },
    MuiRadio: {
      defaultProps: {
        sx: {
          color: "primary.main",
          '&.Mui-checked': {
            color: "secondary.main"
          }
        }
      }
    },
    MuiInputLabel: {
      defaultProps: {
        sx: {
          color: "primary.main"
        }
      }
    },
    MuiOutlinedInput: {
      defaultProps: {
        sx: {
          ".MuiOutlinedInput-notchedOutline": {
            borderColor: "primary.main"
          },
          ".MuiOutlinedInput-notchedOutline:hover": {
            borderColor: "primary.main !important"
          },
          "& .MuiInputBase-input": {
            color: "primary.main"
          },
          "& svg": {
            color: "primary.main"
          },
          "& .MuiFormLabel-root label": {
            color: "primary.main"
          }
        }
      },
      styleOverrides: {
        root: {
          borderRadius: 8
        },
        notchedOutline: {
          borderWidth: 1,
          borderColor: "primary.main",
          "&:hover": {
            borderColor: "primary.main"
          }
        }
      }
    }
  }
});
export default MuscleMuiTheme;